import { useState } from 'react'

export function TruncateExpand({ text }: { text: string }) {
  const [isExpanded, setIsExpanded] = useState(false)
  return (
    <span
      role="button"
      onClick={() => setIsExpanded((prev) => !prev)}
      className={`${isExpanded ? 'line-clamp-none' : 'line-clamp-1'}`}
    >
      {text}
    </span>
  )
}
